import React, {Component} from 'react'
import { movies } from './movies';

class MoviePreviewTwo extends Component{

    render(){
        const{movie,setCurrentMovieFunction}= this.props;
        return (<button
            onClick={() =>setCurrentMovieFunction(movie)} >
            <p>{movie.title}</p>
            <p>{movie.releaseYear}</p>
            <img
            alt={movie.title}
            src={movie.posterUrl}
            height={250}
            />
        </button>
        )
    }
}
export default MoviePreviewTwo;
